/**
 * Plush quantity guard.
 *
 * Keeps the quantity field within its min/max instead of letting shoppers type
 * anything. Rather than making the field read-only (which would force someone
 * wanting 10 units to click "+" ten times), it clamps the value and briefly
 * explains why, so the field stays usable but can never hold an invalid number.
 */
(function () {
  'use strict';

  function clampInput(input) {
    if (input.dataset.plushGuard === '1') return;
    input.dataset.plushGuard = '1';

    var wrapper = input.closest('.quantity') || input.parentElement;

    function noteEl() {
      var existing = wrapper.parentElement.querySelector('.plush-qty-note');
      if (existing) return existing;
      var el = document.createElement('p');
      el.className = 'plush-qty-note';
      el.setAttribute('role', 'status');
      wrapper.parentElement.appendChild(el);
      return el;
    }

    function say(message) {
      var el = noteEl();
      el.textContent = message;
      el.classList.add('is-visible');
      clearTimeout(el._t);
      el._t = setTimeout(function () {
        el.classList.remove('is-visible');
      }, 3200);
    }

    function clamp(showMessage) {
      var min = parseInt(input.getAttribute('min'), 10);
      var max = parseInt(input.getAttribute('max'), 10);
      var raw = input.value.replace(/[^\d]/g, '');

      if (raw === '') return; // let them clear it mid-edit

      var value = parseInt(raw, 10);

      if (!isNaN(max) && value > max) {
        value = max;
        if (showMessage) say('Only ' + max + ' available.');
      }
      if (!isNaN(min) && value < min) {
        value = min;
        if (showMessage) say('Minimum quantity is ' + min + '.');
      }

      if (String(value) !== input.value) input.value = value;
    }

    // Quantity is changed with the +/- buttons only. Applied via JS rather than in
    // the markup so that if scripts fail the field stays typeable (the buttons need
    // JS anyway, so a hardcoded readonly would leave no way to change quantity).
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('inputmode', 'none');

    // Strip anything non-numeric that still gets in (paste, autofill, extensions).
    input.addEventListener('input', function () {
      var cleaned = input.value.replace(/[^\d]/g, '');
      if (cleaned !== input.value) input.value = cleaned;
    });

    input.addEventListener('change', function () {
      clamp(true);
    });
    input.addEventListener('blur', function () {
      clamp(true);
    });

    // Block e, E, +, - and decimal points, which number inputs otherwise accept.
    input.addEventListener('keydown', function (event) {
      if (['e', 'E', '+', '-', '.', ','].indexOf(event.key) !== -1) {
        event.preventDefault();
      }
    });

    // Final safety net: clamp before the form can submit.
    var form = input.form || input.closest('form');
    if (form) {
      form.addEventListener('submit', function () {
        clamp(false);
      });
    }
  }

  function init() {
    document.querySelectorAll('.quantity__input').forEach(clampInput);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
})();
